module.exports = __webpack_public_path__ + "img/Group946.e44bf1f4.png";